import React, { useState } from 'react';
import SubjectDropdown from '../helperComponent/SubjectDropdown';

const AddCourseForm = ({ addCourse }) => {
  const [title, setTitle] = useState('');
  const [price, setPrice] = useState(0);
  const [offerPrice, setOfferPrice] = useState(0);
  const [description, setDescription] = useState('');
  const [image, setImage] = useState([]);
  const [sub, setSub] = useState('');

  const handleAddCourse = (e) => {
    e.preventDefault();
    addCourse({ title, price, offerPrice, description, image, sub });
  };

  // Image upload
  const handleImageUpload = (e) => {
    e.preventDefault();
    const file = e.target.files;
    setImage(file[0]);
  };

  //handle offer price
  const handleOfferPrice = (e) => {
    const op = e.target.value;
    if (op < 0) {
      setOfferPrice(0);
    } else if (parseInt(op, 10) > parseInt(price, 10)) {
      setOfferPrice(price);
    } else {
      setOfferPrice(e.target.value);
    }
  };

  return (
    <form className='class-form' onSubmit={(e) => handleAddCourse(e)}>
      <div className='form-control'>
        <label htmlFor='title'>Course Title</label>
        <input
          type='text'
          value={title}
          required
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='subject'>Subject</label>
        <SubjectDropdown setSub={setSub} />
      </div>
      <div className='form-control'>
        <label htmlFor='item'>Description</label>
        <textarea
          className='update-detail'
          type='text'
          value={description}
          required
          onChange={(e) => setDescription(e.target.value)}
        ></textarea>
      </div>
      <div className='form-control'>
        <label htmlFor='price'>Price</label>
        <input
          type='number'
          value={price}
          required
          onChange={(e) => setPrice(e.target.value < 0 ? 0 : e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='offerPrice'>Offer Price</label>
        <input
          type='number'
          value={offerPrice}
          required
          onChange={(e) => handleOfferPrice(e)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='image'>Preview Image</label>
        <input
          type='file'
          name='uploadImage'
          required
          accept='image/x-png,image/gif,image/jpeg'
          onChange={(e) => handleImageUpload(e)}
        />
      </div>
      <button type='submit' className='btn'>
        Add Course
      </button>
    </form>
  );
};

export default AddCourseForm;
